import {
  Box,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Button,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { useState, useRef, useEffect } from "react";
import InsightsMagicSvg from "../../assets/meeting/insights-magic.svg";
import { getAskQuery } from "../../services/integrations/GlobalSearchService";

const Ask7G = () => {
  const suggestions = [
    "Tell me more about Vidmob",
    "Vidmob is the official partner of which Ad Platforms?",
    "Who are the key people",
  ];

  const [input, setInput] = useState("");
  const [messages, setMessages] = useState<{ sender: "user" | "bot"; text: string }[]>([]);
  const [loading, setLoading] = useState(false);
  const messageContainerRef = useRef<HTMLDivElement>(null);

  const handleAsk = async () => {
    if (!input.trim()) return;
    const question = input.trim();
    setMessages((prev) => [...prev, { sender: "user", text: question }]);
    setInput("");
    setLoading(true);
    try {
      const response = await getAskQuery({
        query: question,
      });

      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: response?.answer ?? "No response found." },
      ]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Something went wrong. Please try again." },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleSuggestionClick = (text: string) => {
    setInput(text);
    setMessages([]);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleAsk();
    }
  };

  useEffect(() => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: 2,
        pt: 4,
      }}
    >
      {messages.length === 0 ? (
        <>
          <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mt: 5,
                mb: 5,
            }}
            >
            <Box
                component="img"
                src={InsightsMagicSvg}
                alt="Insights Magic"
                sx={{
                width: 40,
                height: 40,
                }}
            />
            <Typography
                variant="h5"
                sx={{
                fontWeight: 500,
                textAlign: "center",
                fontFamily: 'var(--font-family)',
                fontSize: "24px",
                }}
            >
                Never Miss an Opportunity to Wow
            </Typography>
            </Box>

          <Box sx={{ textAlign: "initial", mb: 1, maxWidth: "800px", paddingTop: "120px" }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 500, mb: 3 }}>
              Suggestions on what to ASK 7G
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: "nowrap",
                justifyContent: "center",
                gap: 3,
                mb: 5,
              }}
            >
              {suggestions.map((text, index) => (
                <Button
                  key={index}
                  variant="outlined"
                  onClick={() => handleSuggestionClick(text)}
                  sx={{
                    borderRadius: "10px",
                    textTransform: "none",
                    fontFamily: 'var(--font-family)',
                    fontSize: 12,
                    backgroundColor: "#fff",
                    borderColor: "#b902ca",
                    color: "black",
                  }}
                >
                  {text}
                </Button>
              ))}
            </Box>
          </Box>
        </>
      ) : (
        <Box
          ref={messageContainerRef}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            maxWidth: "1200px",
            width: "100%",
            height: "450px",
            overflowY: "auto",
            '&::-webkit-scrollbar-thumb': {
                height: '2px', 
            },
            pr: 2,
            mb: 2,
            scrollbarWidth: "thin",
          }}
        >
          {messages.map((msg, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: msg.sender === "user" ? "flex-start" : "flex-end",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  mb: 0.5,
                  color: "#888",
                  fontFamily: 'var(--font-family)',
                }}
              >
                {msg.sender === "user" ? "You" : "7G"}
              </Typography>

              <Box
                sx={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: 2,
                  maxWidth: "70%",
                  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                  fontFamily: 'var(--font-family)',
                  marginBottom: 3,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "pre-line", color: "#333" }}
                >
                  {msg.text}
                </Typography>
              </Box>
            </Box>
          ))}
          {loading && (
            <Typography variant="body2" sx={{ textAlign: "right", opacity: 0.6 }}>
              Analyzing...
            </Typography>
          )}
        </Box>
      )}
      <Box sx={{ width: "100%", maxWidth: 800 }}>
        <TextField
          placeholder="Ask me anything"
          fullWidth
          variant="outlined"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyPress}
          InputProps={{
            sx: {
              borderRadius: "16px",
              backgroundColor: "#fff",
              fontFamily: 'var(--font-family)',
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end" color="primary" onClick={handleAsk}>
                  <SendIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );
};

export default Ask7G;
